import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';
import axios from 'axios';
import validator from 'validator';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//styles
import './signup.styl';
import 'bootstrap/dist/css/bootstrap.css';
//text
import { text, login } from '../input-text/en/signup_page';
//config
const baseUrl = require('Config').baseUrl;

class Signup extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      email: '',
      password: '',
      passwordConf: '',
      firstName: '',
      lastName: '',
      company: '',
      wantsNewsletter: true,
      agreesWithTerms: false,
      popupText: 'Processing... Just a moment please..'
    }
  }

  inputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  checkboxChange = (e) => {
    this.setState({[e.target.name]: e.target.checked})
  }

  sanitize = () => {
    this.setState({
      email: validator.escape(this.state.email),
      password: validator.escape(this.state.password),
      passwordConf: validator.escape(this.state.passwordConf),
      firstName: validator.escape(this.state.firstName),
      lastName: validator.escape(this.state.lastName),
      company: validator.escape(this.state.company)
    });
  }

  validate = () => {
    //sanitize input
    this.sanitize();
    //validate
    let valid_email = validator.isEmail(this.state.email);
    let valid_password = validator.isByteLength(this.state.password, {min: 6, max: undefined});
    let match_pass = (this.state.password === this.state.passwordConf);
    // TODO: match firstname lastname validation logic server side
    let valid_firstName = this.state.firstName.trim().split(" ").every(val => validator.isAlpha(val)) &&
                          validator.isByteLength(this.state.firstName, {min: 1, max: undefined});
    let valid_lastName = this.state.lastName.trim().split(" ").every(val => validator.isAlpha(val)) &&
                          validator.isByteLength(this.state.lastName, {min: 1, max: undefined});

    if(!valid_email)
      this.setState({popupText: 'Please provide a valid email'});
    else if(!valid_password)
      this.setState({popupText: 'Please provide password of minimum 6 characters long'});
    else if(!match_pass)
      this.setState({popupText: 'Passwords do not match'});
    else if(!valid_firstName)
      this.setState({popupText: 'Please provide a valid first name'});
    else if(!valid_lastName)
      this.setState({popupText: 'Please provide a valid last name'});
    else if(!this.state.agreesWithTerms)
      this.setState({popupText: 'Please agree with our terms'});
    else if(valid_email && valid_password && valid_firstName && valid_lastName){
      return true;
    }
  }

  popup = () => {
    return (
      <Tooltip className="in" id="tooltip-top">
        <span>{this.state.popupText}</span>
      </Tooltip>
    );
  }

  submitForm = (e) => {
    e.preventDefault();
    const url = `${baseUrl}/users/create`;

    if(this.validate()){

      axios.post(url, {
        email: this.state.email,
        password: this.state.password,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        company: this.state.company,
        wantsNewsletter: this.state.wantsNewsletter,
        agreesWithTerms: this.state.agreesWithTerms
      })
      .then(response =>{
        this.setState({popupText: 'Just a moment..'});
        this.context.router.history.push('/confirm');
      })
      .catch(err=>{
        this.setState({popupText: err.response.data.status});
      });
    }
  }

  render(){
    return (
      <div className="sign-up-page">
        <div className="container">
          <h1 className='sign-up-page__title'>{text._title}</h1>
          <form className="sign-up-page__form" onSubmit={ this.submitForm }>
            <div className="row">
              <div className="col-sm-6">
                <div className="sign-up-page__form__input-field">
                  <label htmlFor="email" className='form-text'>{text._email}<sup>*</sup></label>
                  <input id="email" type='email' name='email' className='input email' value={this.state.email} onChange={this.inputChange} />
                </div>
                <div className="sign-up-page__form__input-field">
                  <label htmlFor="password" className='form-text'>{text._password}<sup>*</sup></label>
                  <input id="password" type='password' name='password' className='input password' value={this.state.password} onChange={this.inputChange} />
                </div>
                <div className="sign-up-page__form__input-field">
                  <label htmlFor="passwordConf" className='form-text'>{text._passwordConf}<sup>*</sup></label>
                  <input id="passwordConf" type='password' name='passwordConf' className='input password' value={this.state.passwordConf} onChange={this.inputChange} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="sign-up-page__form__input-field">
                  <label htmlFor="firstName" className='form-text'>{text._firstName}<sup>*</sup></label>
                  <input id="firstName" type='text' name='firstName' className='input firstName' value={this.state.firstName} onChange={this.inputChange} />
                </div>
                <div className="sign-up-page__form__input-field">
                  <label htmlFor="lastName" className='form-text'>{text._lastName}<sup>*</sup></label>
                  <input id="lastName" type='text' name='lastName' className='input lastName' value={this.state.lastName} onChange={this.inputChange} />
                </div>
                <div className="sign-up-page__form__input-field">
                  <label htmlFor="company" className='form-text'>{text._company}</label>
                  <input id="company" type='text' name='company' className='input company' value={this.state.company} onChange={this.inputChange}/>
                </div>
              </div>
            </div>
            <div className="sign-up-page__form__actions">
              <div>
                <input id="wantsNewsletter" className='form-checkbox' type='checkbox' name='wantsNewsletter' value={true} onChange={this.checkboxChange} checked={this.state.wantsNewsletter}/>
                <label htmlFor="wantsNewsletter">{' '+text._newsletter}</label>
              </div>
              <div>
                <input id="agreesWithTerms" className='form-checkbox' type='checkbox' name='agreesWithTerms' value={true} onChange={this.checkboxChange} checked={this.state.agreesWithTerms}/>
                <label htmlFor="agreesWithTerms" dangerouslySetInnerHTML={{ __html: ' '+text._terms }}></label>
              </div>
              <OverlayTrigger className='form-overlay' trigger={'click'} placement="bottom" overlay={this.popup()}>
                <button type="submit" className="button">{text._submit}</button>
              </OverlayTrigger>
            </div>
          </form>
        </div>
        <SimpleContainer color='white' containerClass='signup-strip padded-container'>
          <h1>{login._title}</h1>
          <p><Link to='/login/'>Login</Link>{login._body}</p>
        </SimpleContainer>
      </div>
    );
  }
};

Signup.contextTypes = {
  router: PropTypes.object.isRequired
}

export default Signup;



// WEBPACK FOOTER //
// ./src/routes/Signup.js